import React from 'react';
import { resolveImage } from '../../../utils/api';
import BilingualField from '../../../components/common/BilingualField';

export default function HeroEditor({ content, handleBilingualChange, handleChange, handleImageChange, heroImagePreview }) {
  return (
    <div className="dash-card mb-4" style={{ maxWidth: 900 }}>
      <h3 className="dash-card-title mb-4">Hero Section</h3>

      <BilingualField
        label="Main Headline (Use \n for new lines)"
        fieldName="heroHeadline"
        value={content.heroHeadline}
        onChange={handleBilingualChange}
        isTextarea
        rows={3}
        placeholder="Where\nBallet\nBecomes Life."
      />

      <BilingualField
        label="Subtext"
        fieldName="heroSubtext"
        value={content.heroSubtext}
        onChange={handleBilingualChange}
        isTextarea
        rows={3}
        placeholder="ETS brings the full dance academy experience..."
      />

      <div className="form-row-2">
        <BilingualField
          label="Top Left Label"
          fieldName="heroLabel"
          value={content.heroLabel}
          onChange={handleBilingualChange}
          placeholder="e.g. Classical Ballet"
        />
        <BilingualField
          label="Top Right Badge (Use \n for new lines)"
          fieldName="heroBadge1"
          value={content.heroBadge1}
          onChange={handleBilingualChange}
          isTextarea
          rows={2}
          placeholder="10+\nYears of Dance"
        />
      </div>

      <BilingualField
        label="Side Rating Badge (Use \n for new lines)"
        fieldName="heroBadge2"
        value={content.heroBadge2}
        onChange={handleBilingualChange}
        isTextarea
        rows={2}
        placeholder="4.9 / 5.0\nStudent Rating"
      />

      <div className="form-group" style={{ marginTop: 24 }}>
        <label className="form-label-style">Hero Image Background</label>
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
          <div
            style={{
              width: 200,
              height: 150,
              background: '#f0f0f0',
              borderRadius: 8,
              backgroundImage: heroImagePreview ? `url("${heroImagePreview}")` : (content.heroImageUrl ? `url("${resolveImage(content.heroImageUrl)}")` : 'none'),
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              border: '1px solid var(--border)'
            }}
          />
          <div>
            <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'hero')} style={{ marginBottom: 12 }} />
            <p className="text-sm text-muted">Recommended size: 1200x800px.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
